import { isDefined } from "../../helpers";
export default function (store, { id, batchID, $meta }) {
    const task = store.getTask(id);
    const parent = store.getTask(task?.parent);
    const state = store.getState();
    const filtered = isDefined(state.filter?.match);
    const hideCompleted = state?.taskShape?.completed?.taskHide;
    const children = store.getChildren({
        id: parent?.id,
        tree: false,
        filtered,
        hideCompleted,
    });
    const index = store.getTreeIndex(id, filtered, hideCompleted);
    if (index > 0) {
        const target = store.getTask(children[index - 1]?.id);
        store.in.exec("move-task", {
            id,
            parent: target?.id,
            targetId: target?.id,
            operation: "indent",
            batchID,
            $meta,
        });
        if (target.collapsed) {
            store.in.exec("expand-task", { id: target?.id });
        }
    }
}
//# sourceMappingURL=indent.js.map